// Routes redesigned in the programmes group. Each entry: { path, element }.
// Entries here override the legacy routes in App.jsx for the same path.
import ProgrammesHubPage from "./ProgrammesHubPage.jsx";
import AarohPage from "./AarohPage.jsx";
import AuroraPage from "./AuroraPage.jsx";
import MetamorphosisPage from "./MetamorphosisPage.jsx";
import UpcomingPage from "./UpcomingPage.jsx";

export const routes = [
  { path: "/programmes", element: <ProgrammesHubPage /> },
  { path: "/programmes/aaroh", element: <AarohPage /> },
  { path: "/programmes/aurora", element: <AuroraPage /> },
  { path: "/programmes/metamorphosis", element: <MetamorphosisPage /> },
  { path: "/programmes/upcoming", element: <UpcomingPage /> },
];
